module.exports = __webpack_public_path__ + "img/54.1.a7ee0a82.jpg";